import service from "@/api/request";
//获取活动列表
export const getActivityList = (data) => service.getByParams(`/courseAdmin/redeem/activity/list`, data);
//获取渠道列表选项
export const getChannelOptionList = () => service.getByQuery(`/courseAdmin/redeem/channel/queryList`);
//修改活动状态
export const changeActivityStatus = (data = {}) => service.postByJson(`/courseAdmin/redeem/activity/updateStatus`, data);
//创建活动
export const saveActivity = (data = {}, headers = {}) => service.postByJson(`/courseAdmin/redeem/activity/save`, data, headers);
//创建活动
export const getAllCourseOptionList = (data = {}) => service.getByQuery(`/courseAdmin/CourseContent/getAllSimpleCourseList`);
//获取兑换码列表
export const getRedeemCodelist = (data = {}) => {
    return service.getByParams(`/courseAdmin/redeem/redeemCode/list`, data);
};
//获取渠道列表
export const getChannellist = (data = {}) => {
    return service.getByParams(`/courseAdmin/redeem/channel/list`, data);
};
//修改渠道状态
export const changeChannelStatus = (data = {}, headers = {}) => {
    return service.postByJson(`/courseAdmin/redeem/channel/updateHiddenStatus`, data, headers);
};
//添加渠道
export const saveChannel = (data = {}, headers = {}) => {
    return service.postByJson(`/courseAdmin/redeem/channel/save`, data, headers);
};
